<div class="asset-chart">

  <div #asset_chartdiv [id]="'asset-chart__chart_' + asset.id"></div>

</div>

